exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".query_item_f5adff7{border-bottom:1px solid #e3e3e3}.query_657850d,.query_item_f5adff7{height:60px;line-height:60px;margin-bottom:0!important}.query_657850d .label_17dfcfa{color:#000;font-size:14px}.query_657850d .value_d90f9dc{color:#1890ff;font-size:24px}", ""]);

// exports
exports.locals = {
	"query_item": "query_item_f5adff7",
	"query": "query_657850d",
	"label": "label_17dfcfa",
	"value": "value_d90f9dc"
};